import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/config";
import { AppDispatch, RootState } from "../store";
import {
  ApiReturn,
  GetTransactionsParams
} from "./transactions.types";

export const getTransactions = createAsyncThunk<
  ApiReturn,
  GetTransactionsParams,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("transactions/get", async (params: GetTransactionsParams, thunkApi) => {
  const state = thunkApi.getState();
  const products = state.products as {
    productSelected?: { value: any };
  };
  const businessLines = state.businessLines as {
    businessLineSelected?: { id: any };
  };
  const business_line_id = businessLines.businessLineSelected?.id;
  const product_id = products.productSelected?.value;

  const {
    ownerId,
    ownerType = "client",
    ...requestParams
  } = params;
  const finalParams = { ...requestParams, product_id, business_line_id };

  const response = ownerType === "client"
    ? await api.post("api/client-transactions", {
      ...finalParams,
      client_id: ownerId
    })
    : await api.get(
      ownerType === "company"
        ? `api/companies/${ownerId}/transactions`
        : `api/contractors/${ownerId}/transactions`,
      { params: finalParams }
    );

  return {
    data: response.data,
    params
  };
});
